import { render, staticRenderFns } from "./UsersRequests.vue?vue&type=template&id=55d1701f&"
import script from "./UsersRequests.vue?vue&type=script&lang=ts&"
export * from "./UsersRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports